import axios from "axios";
import moment from "moment";

import CryptoJS from "crypto-js";
import { toJS } from "mobx";

const secretKey = "5t_f4A]O~)^,w<z8fZc2j<biHmU=v.";

const { VITE_API_URL, VITE_UPLOAD_URL } = import.meta.env;

let headers = {
    "Content-Type": "application/json",
};

let headerUpload = {
    "Req-From": "web",
};

let headersFileUpload = {
    "Req-From": "web",
    "content-type": "multipart/form-data",
};

if (localStorage.getItem("_cms_token_v1")) {
    headers["Authorization"] = localStorage.getItem("_cms_token_v1");
    headerUpload["Authorization"] = localStorage.getItem("_cms_token_v1");
    headersFileUpload["Authorization"] = localStorage.getItem("_cms_token_v1");
}
const instance = axios.create({
    baseURL: VITE_API_URL,
    headers: headers,
    withCredentials: true,
    responseType: "json",
});

const inctanceUpload = axios.create({
    baseURL: VITE_UPLOAD_URL,
    headers: headerUpload,
    withCredentials: true,
    responseType: "json",
});

const inctanceFileUpload = axios.create({
    baseURL: VITE_API_URL,
    headers: headersFileUpload,
    withCredentials: true,
    // responseType: "json",
});

instance.interceptors.request.use((config) => {
    config.headers["Req-Time"] = moment().toISOString(true);
    return config;
});

inctanceUpload.interceptors.request.use((config) => {
    config.headers["Req-Time"] = moment().toISOString(true);
    return config;
});

inctanceFileUpload.interceptors.request.use((config) => {
    config.headers["Req-Time"] = moment().toISOString(true);
    return config;
});

const _getByUrlData = async (url, data = false, isCda = true) => {
    try {
        _initServiceAfterAuth(localStorage.getItem("_cms_token_v1"));
        const cda = isCda && data ? generateHash(data) : false;
        let req = await instance.get(`${url}${cda ? "?cda=" + cda : ""}`);
        if (req.data) {
            return req.data;
        }
    } catch (e) {
        console.log(e);
        return { success: false, msg: e.message, dataError: e };
    }
};

const _postByUrlData = async (url, data, isCda = true) => {
    try {
        let req = await instance.post(url, isCda ? { cda: generateHash(data) } : data);
        if (req.data) {
            return req.data;
        }
    } catch (e) {
        console.log(e);
        return { success: false, msg: e.message, dataError: e };
    }
};
const _putByUrlData = async (url, data) => {
    try {
        let req = await instance.put(url, { cda: generateHash(data) });
        if (req.data) {
            return req.data;
        }
    } catch (e) {
        console.log(e);
        return { success: false, msg: e.message, dataError: e };
    }
};
const _deleteByUrlData = async (url, data = false, isCda = true) => {
    try {
        _initServiceAfterAuth(localStorage.getItem("_cms_token_v1"));
        const cda = isCda && data ? generateHash(data) : false;
        let req = await instance.delete(`${url}`, { data: { cda: cda } });
        if (req.data) {
            return req.data;
        }
    } catch (e) {
        console.log(e);
        return false;
    }
};

const _uploadImage = async (url, file) => {
    try {
        let req = await inctanceUpload.post(`upload_image?path=${url}`, file);
        if (req.data && req.data.success) {
            return req.data;
        } else {
            console.log("error", req.data.msg, req.data.err ? req.data.err : "");
            return req.data;
        }
    } catch (e) {
        console.log(e);
        return { success: false, msg: e.message, dataError: e };
    }
};

const _uploadFile = async (url, file, options, cda = false) => {
    try {
        let req = await inctanceFileUpload.post(`${url}`, cda ? { cda: generateHash(file) } : file, options);
        if (req.data && req.data.success) {
            return req.data;
        } else {
            console.log("error", req.data.msg, req.data.err ? req.data.err : "");
            return req.data;
        }
    } catch (e) {
        console.log(e);
        return { success: false, msg: e.message, dataError: e };
    }
};

const _initServiceAfterAuth = async (authToken) => {
    if (authToken) {
        instance.defaults.headers["Authorization"] = authToken;
    } else {
        delete instance.defaults.headers["Authorization"];
    }
    return true;
};

const generateHash = (data) => encodeURIComponent(CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString());

export { _getByUrlData, _postByUrlData, _putByUrlData, _deleteByUrlData, _initServiceAfterAuth, _uploadImage, _uploadFile };
